import { Icon } from "leaflet";
import TargetMarker from "../../../../assets/images/targetMarker.png";

export const IconTarget = new Icon({
  iconUrl: TargetMarker,
  iconSize: [32, 32],
  iconAnchor: [16, 32],
  popupAnchor: [0, -32],
  shadowUrl: null,
  shadowSize: null,
  shadowAnchor: null,
});
